var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAngleUp = function SvgAngleUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.434 15.849c.198.198.297.296.411.334.1.032.21.032.31 0 .114-.038.213-.136.41-.335L12 10.415l5.434 5.435c.198.198.297.296.412.334.1.032.208.032.308 0 .115-.038.214-.136.412-.335l.283-.282c.198-.198.296-.297.334-.412a.5.5 0 0 0 0-.309c-.038-.114-.136-.213-.334-.41L12.566 8.15c-.198-.198-.297-.297-.412-.334a.5.5 0 0 0-.309 0c-.114.037-.213.136-.41.334L5.15 14.434c-.198.198-.297.297-.334.412a.5.5 0 0 0 0 .309c.037.114.136.213.334.41z",
    clipRule: "evenodd"
  })));
};
export default SvgAngleUp;